module.exports = __webpack_public_path__ + "img/sujiyuding-app-code.9188eb09.jpg";